import { usuario } from './../models/user';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Component, OnInit } from '@angular/core';
import { ServerService } from "../server.service";
import Swal from 'sweetalert2'

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css']
})
export class RegistroComponent implements OnInit {
  credentialsInvalid: boolean = false; // credenciales validas
  regex = new RegExp('^(?=.*[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,15}$');
  messageError: string = '';


  active = 1;


  myForm = new FormGroup({


    carnet: new FormControl("", [
      Validators.required,
      Validators.pattern('[0-9]+'),
      Validators.minLength(9), //min de tamañao para carnet 201443728
      Validators.maxLength(9)
    ]),
    userName: new FormControl("", [
      Validators.required,
      Validators.minLength(4), //min de tamañao para usuario

    ]),
    userLastName: new FormControl("", [
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(20)
    ]),
    userEmail: new FormControl("", [
      Validators.required,
      Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),
      Validators.email,
    ]),
    userPass: new FormControl("", [
      Validators.required,
      Validators.minLength(7),
      Validators.maxLength(15),
      Validators.pattern('^(?=.*[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{7,15}$')

    ]),
    userPassConfirm: new FormControl("", [
     Validators.required,
     Validators.minLength(7),
     Validators.maxLength(15),
     ]),

  });

  constructor(private server: ServerService) { }

  ngOnInit(): void {

  }

  onSubmit(): void {
    const user = this.myForm.value;


    if( user.carnet === '' ||  user.userName === '' || user.userLastName === '' || user.userPass === '' || user.userEmail === ''
      ){

        this.credentialsInvalid = true;
         this.messageError = 'Faltan campos a ingresar';
         setTimeout(() => {this.credentialsInvalid = false;},3500);
         return;

    }
    else if(user.carnet.lenght<9){

      this.credentialsInvalid = true;
      this.messageError = 'El carnet debe tener 9 dígitos';
      setTimeout(() => {this.credentialsInvalid = false;},3500);
      return;
    }
    if(user.userPass != user.userPassConfirm){

      this.credentialsInvalid = true;
      this.messageError = 'La contraseña no coincide';
      setTimeout(() => {this.credentialsInvalid = false;},3500);
      return;
    }


    const usuario: usuario = {
      carnet:            user.carnet,
      nombre:            user.userName,
      apellido:          user.userLastName,
      correo:            user.userEmail,
      password:          user.userPass,
      passwordconfir:    user.userPassConfirm,
      estado:            1,
      idRol:             3,//rol de estudiante
      banderareseteo:    0,
    }



    if(this.myForm.valid){
      this.server.postRegistro(usuario).subscribe((data: {msg:string})=> {


        if(data["status"] === 'error'){
           this.credentialsInvalid = true;
            this.messageError=="El usuario ya existe"
           setTimeout(() => {this.credentialsInvalid = false;},3500);
          return;

        }
        this.opensweetalert();
        setTimeout(() => location.href='', 4000);
       }
      , error => {
        this.credentialsInvalid = true;
        this.messageError = 'Error en la conexion';
        setTimeout(() => {this.credentialsInvalid = false;},3500);
      })
    }
  }

opensweetalert():void{
  Swal.fire({
    position: 'top',
    icon: 'success',
    title: 'Usuario registrado con exito',
    showConfirmButton: false,
    timer: 4000
  })
}
//gets para obtener en interfaz y hacer validaciones
get carnet() {return this.myForm.get('carnet');}
get userName() {return this.myForm.get('userName');}
get userLastName() {return this.myForm.get('userLastName');}
get userPass() {return this.myForm.get('userPass');}
get userPassConfirm() {return this.myForm.get('userPassConfirm');}
get userEmail() {return this.myForm.get('userEmail');}
}
